import { css } from 'styled-components';
import { colors } from './colors';

export const global = css`
  body {
    background-color: ${colors.neutral08};
    color: ${colors.neutral01};
  }
`;
